import { Step, StepContent, StepLabel, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import NumberFormat from "react-number-format";
import { DoneIcon } from "./StepIcons";
import TransactionHistoryBase from "./TransactionHistoryBase";
import styles from "./styles";
import Note from "./Note";

const WithoutOrderIdSell = ({ amount, unit, completedDate, details }) => (
  <TransactionHistoryBase>
    {/* Completed */}
    <Step active>
      <StepLabel icon={<DoneIcon active />}>
        <Typography
          color="textPrimary"
          style={{
            ...styles.baseFont,
            ...styles.label,
            color: "#000000",
          }}
        >
          Completed
        </Typography>
      </StepLabel>
      <StepContent style={{ marginTop: "0" }}>
        <div
          style={{
            marginTop: "3px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
            }}
          >
            Adjusted Cash Out
          </Typography>
          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
            }}
          >
            RM{" "}
            <NumberFormat
              value={amount}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale
            />
          </Typography>
        </div>
        <div
          style={{
            marginTop: "8px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography style={{ ...styles.baseFont, ...styles.content }}>
            Unit: {unit}
          </Typography>
          <Typography style={{ ...styles.baseFont, ...styles.content, textAlign: "right" }}>
            Unit Price: RM
            <NumberFormat
              value={
                details &&
                details.length > 0 &&
                details[0].actualUnitPrice !== null
                  ? details[0].actualUnitPrice
                  : parseFloat(amount / unit)
              }
              thousandSeparator
              displayType="text"
              decimalScale={4}
              fixedDecimalScale
            />
          </Typography>
        </div>

        <Typography
          style={{
            ...styles.baseFont,
            ...styles.content,
            ...styles.date,
            marginTop: "8px",
          }}
        >
          {moment(completedDate)
            .utcOffset("+0800")
            .format("DD MMM YYYY")}
        </Typography>
      </StepContent>
      <Note>
        Note: Cash out process has been completed. It might take some time to
        reflect in your account.
      </Note>
    </Step>
  </TransactionHistoryBase>
);

export default WithoutOrderIdSell;
